// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bdON","comment":"styles_comment__15gL8"};